import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DateMultiLangPipe } from './date-multi-lang.pipe';
import { DomSanitizerPipe } from './dom-sanitizer.pipe';
import { PointToUnderscorePipe } from './point-to-underscore.pipe';
import { ArrayToStringPipe } from './array-to-string.pipe';
import { FileToBase64Pipe } from './file-to-base64.pipe';

@NgModule({
    declarations: [
        DateMultiLangPipe,
        DomSanitizerPipe,
        PointToUnderscorePipe,
        ArrayToStringPipe,
        FileToBase64Pipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        DateMultiLangPipe,
        DomSanitizerPipe,
        PointToUnderscorePipe,
        ArrayToStringPipe,
        FileToBase64Pipe
    ]
})
export class PipesModule { }
